<template>
  <div class="wecoupon-mall-loading">
    <div class="dot" v-for="(item, i) in dotList" :key="i"></div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue-demi';

export default defineComponent({
  name: 'MallContentLoading',
  components: {},
  setup(props, context) {
    const dotList = ref(new Array(8));
    return {
      dotList,
    };
  },
});
</script>
<style lang="less" scoped>
@import (reference) '../../../less/main.less';

.wecoupon-mall-loading {
  position: relative;
  width: 50px;
  height: 50px;

  .dot {
    width: 4px;
    height: 4px;
    border-radius: 2px;
    background-color: #ffffff;
    position: absolute;
    animation: dot linear 0.8s infinite;
    -webkit-animation: dot linear 0.8s infinite;
  }

  .dot:nth-child(1) {
    left: 24px;
    top: 2px;
    animation-delay: 0s;
  }

  .dot:nth-child(2) {
    left: 40px;
    top: 8px;
    animation-delay: 0.1s;
  }

  .dot:nth-child(3) {
    left: 47px;
    top: 24px;
    animation-delay: 0.1s;
  }

  .dot:nth-child(4) {
    left: 40px;
    top: 40px;
    animation-delay: 0.2s;
  }

  .dot:nth-child(5) {
    left: 24px;
    top: 47px;
    animation-delay: 0.4s;
  }

  .dot:nth-child(6) {
    left: 8px;
    top: 40px;
    animation-delay: 0.5s;
  }

  .dot:nth-child(7) {
    left: 2px;
    top: 24px;
    animation-delay: 0.6s;
  }

  .dot:nth-child(8) {
    left: 8px;
    top: 8px;
    animation-delay: 0.7s;
  }
}

@keyframes dot {
  0%,
  40%,
  100% {
    transform: scale(1);
  }

  20% {
    transform: scale(3);
  }
}

@-webkit-keyframes dot {
  0%,
  40%,
  100% {
    transform: scale(1);
  }

  20% {
    transform: scale(3);
  }
}
</style>
